if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
  document.querySelectorAll('.email-signup__message--success').forEach(function (el) {
    el.removeAttribute('hidden');
  });
  document.querySelectorAll('.email-signup__input-group').forEach(function (el) {
    el.style.display = 'none';
  });
  document.querySelectorAll('.email-signup-block').forEach(function (signupBlock) {
    var sibling = signupBlock.nextElementSibling;
    while (sibling) {
      if (sibling.classList.contains('text-block')) {
        sibling.innerHTML = "<p>We've sent a confirmation email to your inbox. Please click the link inside to confirm your subscription and stay in the loop.</p>";
        sibling.style.paddingBottom = '3rem';
        break;
      }
      sibling = sibling.nextElementSibling;
    }
  });
}
